/**
 * Create a blank screenplay from the committed template. The template supplies
 * the exact Fade In-compatible shell (settings, the 8 built-in styles, empty
 * title page, spelling, generic autocomplete lists); we only mint fresh UUIDs.
 */
import templateXml from "../../fixtures/new_document_template.xml?raw";
import { parseDocument, type ParsedDocument } from "./parse";

/** Generate a v4 UUID, tolerating environments without crypto.randomUUID. */
function uuidV4(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback (should not be needed on Chrome/Android or modern Node).
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
  return (
    hex.slice(0, 4).join("") +
    "-" +
    hex.slice(4, 6).join("") +
    "-" +
    hex.slice(6, 8).join("") +
    "-" +
    hex.slice(8, 10).join("") +
    "-" +
    hex.slice(10, 16).join("")
  );
}

/** Build a fresh, unsaved document ready for the editor. */
export function createNewDocument(): ParsedDocument {
  const parsed = parseDocument(templateXml);
  const info = parsed.dom.getElementsByTagName("info")[0];
  if (info) {
    info.setAttribute("uuid", uuidV4());
    info.setAttribute("draft_uuid", uuidV4());
    info.setAttribute("pagecount", "1");
  }
  return parsed;
}
